import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';
import type { AccountDetails } from '@v2/types';

export const useUpdateAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<AccountDetails> }) =>
      accountsService.updateAccount(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.accounts.all);
    },
  });

  const updateAccount = async (id: string, data: Partial<AccountDetails>): Promise<boolean> => {
    try {
      await mutation.mutateAsync({ id, data });
      return true;
    } catch {
      return false;
    }
  };

  return {
    updateAccount,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useUpdateAccount;
